import React from 'react';
import { Button } from '../../../../common/components';
import { markAsPaid } from '../../../account/redux/accountActions';
import { hasPermission } from '../../../auth/redux/authActions';
import { connect } from 'react-redux';
import { getPolicy } from '../../redux/policyActions';

const MatchPremiumButton = ({ dispatch, brokerId, premiumId, policyId }) => {
  const handleMarkAsPaid = () => {
    Promise.resolve(dispatch(markAsPaid(brokerId, premiumId))).then(() => {
      dispatch(getPolicy(policyId, false));
    });
  };

  if (!brokerId || !premiumId || !hasPermission('account_ledger.match')) {
    return null;
  }

  return (
    <Button
      rightIcon="coins"
      label={'Mark as Paid'}
      bsStyle="primary"
      handleClick={handleMarkAsPaid}
    />
  );
};
export default connect()(MatchPremiumButton);
